
export interface PdfParamsState{
    stichtagsdifferenz: {
        stand: string,
        hoehe: string
    },
    zusaetzlicheBegruendungen: string
}

export default {
    namespaced: true,
    state: {
        stichtagsdifferenz: {
            stand: '',
            hoehe: ''
        },
        zusaetzlicheBegruendungen: 'Adresse:\n------------------------------\nZusätzliche Begründungen:'
    } as PdfParamsState,
    getters: {
    },
    mutations: {
        SET_STICHTAGSDIFFERENZ(state:PdfParamsState, stichtagsdifferenz:PdfParamsState['stichtagsdifferenz']) {
            state.stichtagsdifferenz = stichtagsdifferenz
        },
        SET_ZUSAETZLICHEBEGRUENDUNGEN(state:PdfParamsState, zusaetzlicheBegruendungen:string) {
            state.zusaetzlicheBegruendungen = zusaetzlicheBegruendungen
        }
    },
    actions: {
        SET_PDFPARAMS({ commit, dispatch }: { commit: Function, dispatch: Function }, payload: { stichtagsdifferenz:PdfParamsState['stichtagsdifferenz'], zusaetzlicheBegruendungen:string }) {
            commit('SET_STICHTAGSDIFFERENZ', {
                    stand: payload.stichtagsdifferenz.stand,
                    hoehe: payload.stichtagsdifferenz.hoehe
                })
            commit('SET_ZUSAETZLICHEBEGRUENDUNGEN', payload.zusaetzlicheBegruendungen)
        },
        RESET_PDFPARAMS({ commit, dispatch }: { commit: Function, dispatch: Function }){
            commit('SET_STICHTAGSDIFFERENZ', {
                    stand: '',
                    hoehe: ''
                })
            commit('SET_ZUSAETZLICHEBEGRUENDUNGEN', 'Adresse:\n------------------------------\nZusätzliche Begründungen:')
        }
    }
}